export const youtubeVideoUrlFormats = [
  "https://www.youtube.com/watch?v=",
  "https://www.youtube.com/shorts/",
  "https://youtu.be/",
];
